import React, { createContext } from 'react';

export interface DatabaseContent {
  activationId: string | null;
  cloudId: string;
  contentId: string;
  entryId: string | null;
  fieldId: string | null;
  /**
   * The content ID of the database parent in Confluence, i.e. where the database is
   * embedded. In standalone, it's just the content ID of the database. It's
   * null if it's embedded not in Confluence or cross-origin.
   * */
  parentContentId: string | null;
  referenceId: string | null;
  referencing: boolean;
  savedViewId: string | null;
  setContentId: (contentId: string) => void;
  spaceId: string;
  spaceKey: string;
  spaceName?: string;
  title?: string;
  unsavedViewId: string | null;
}

export const DatabaseContentContext = createContext<DatabaseContent | undefined>(
  undefined
);

export const DatabaseContentContextProvider: React.FC<{
  value: DatabaseContent;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <DatabaseContentContext.Provider value={value}>
    {children}
  </DatabaseContentContext.Provider>
);

/**
 * Get the top window in the window hierarchy.
 */
export function getParentWindow(): Window {
  try {
    let currentWindow: Window = window;

    while (
      currentWindow.location.toString() !== currentWindow.parent.location.toString()
    ) {
      currentWindow = currentWindow.parent;
    }

    return currentWindow;
  } catch {
    // If we're in an iframe and the parent is on a different domain, we can't access it.
    // In this case we fall back to the current window. This covers the case where the app is
    // embedded in a different domain (e.g. in a different tenant) via smartlink.
    return window;
  }
}
